'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(require("q"), require("bridge"));else if (typeof define === 'function' && define.amd) define("jsbridge", ["q", "bridge"], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["jsbridge"] = factory(require("q"), require("bridge"));else root["jsbridge"] = factory(root["q"], root["bridge"]);
})(undefined, function (__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};
			/******/
			/******/ // The require function
			/******/function __webpack_require__(moduleId) {
				/******/
				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;
				/******/
				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };
				/******/
				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
				/******/
				/******/ // Flag the module as loaded
				/******/module.loaded = true;
				/******/
				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}
			/******/
			/******/
			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;
			/******/
			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;
			/******/
			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "/build/";
			/******/
			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			/**
    * @module JSBridge
    **/
			"use strict";

			Object.defineProperty(exports, "__esModule", {
				value: true
			});

			var _createClass = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
					}
				}return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
				};
			}();

			var _q = __webpack_require__(1);

			var _q2 = _interopRequireDefault(_q);

			var _bridge = __webpack_require__(2);

			var _bridge2 = _interopRequireDefault(_bridge);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}

			function _possibleConstructorReturn(self, call) {
				if (!self) {
					throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
				}return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
			}

			function _inherits(subClass, superClass) {
				if (typeof superClass !== "function" && superClass !== null) {
					throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
				}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
			}

			var userAgent = navigator.userAgent;
			var isTB = !!(/WindVane/i.test(userAgent) && !/T-UA/i.test(userAgent));
			var isAlipay = !!/Alipay/ig.test(userAgent);

			/**
    * @class JSBridge
    * @constructor
    */

			var JSBridge = function (_Bridge) {
				_inherits(JSBridge, _Bridge);

				function JSBridge() {
					_classCallCheck(this, JSBridge);

					return _possibleConstructorReturn(this, Object.getPrototypeOf(JSBridge).apply(this, arguments));
				}

				_createClass(JSBridge, [{
					key: 'getEnv',

					/**
      * @description 获取环境变量
      *
      * @returns {promise|*|defer.promise|Q.promise}
      */
					value: function getEnv() {
						var deferred = _q2.default.defer();

						//航旅IOS桥处理 version < 5.0
						if (this.platform === 'ios' && this.client.version < 5.0) {
							//daily 代表日常，prepare 代表预发，online 代表线上
							var map = {
								daily: 'waptest',
								prepare: 'wapa',
								online: 'm'
							};
							var successCallback = function successCallback(result) {
								deferred.resolve(map[JSON.parse(result).environment]);
							};
							this.pushBack('bridge:', 'getEnvironment', { successCallback: successCallback });

							//wap、手淘|航旅
						} else {
								var hostname = location.hostname;
								var env = /waptest/.test(hostname) ? 'waptest' : /wapa/.test(hostname) ? 'wapa' : 'm';

								deferred.resolve(env);
							}

						return deferred.promise;
					}

					/**
      * @description 获取渠道ID
      * @returns {promise|*|defer.promise|Q.promise}
      */

				}, {
					key: 'getTTid',
					value: function getTTid() {
						var deferred = _q2.default.defer();

						//识别钱包新容器
						if (/AlipayClient/i.test(navigator.userAgent)) {
							//有域，ttid可以透传
							if (location.search.match(/ttid=([^=&]+)/)) {
								var match = location.search.match(/ttid=([^=&]+)/);
								ttid = match ? match[1] : '201300@travel_h5_3.1.0';

								deferred.resolve(ttid);
							} else {
								var readyCallback = function readyCallback() {
									try {
										var ttid = AlipayJSBridge.startupParams.ttid;
										deferred.resolve(ttid);
									} catch (e) {
										deferred.reject('AlipayJSBridge get ttid failed.');
									}
								};

								//针对钱包容器已经完成桥初始化的情况
								if (window.AlipayJSBridge && AlipayJSBridge.call) {
									readyCallback();
								} else {
									//钱包新容器（创建桥的方式是异步的）
									document.addEventListener('AlipayJSBridgeReady', readyCallback, false);
								}
							}

							//wap、手淘|航旅(有域，location可用)
						} else {
								var match = location.search.match(/ttid=([^=&]+)/) || location.hash.match(/ttid=([^=&]+)/);

								//默认为航旅H5渠道ID
								var ttid = match ? match[1] || '201300@travel_h5_3.1.0' : '201300@travel_h5_3.1.0';

								deferred.resolve(ttid);
							}

						return deferred.promise;
					}

					/**
      * @description 设置标题
      */

				}, {
					key: 'setTitle',
					value: function setTitle(title) {
						if (isTB) {
							window.WindVane.call('WebAppInterface', 'setCustomPageTitle', { 'title': title }, function (e) {}, function (e) {});
						} else if (isAlipay) {
							var readyCallback = function readyCallback() {
								AlipayJSBridge.call("setTitle", {
									title: title
								});
							};

							if (window.AlipayJSBridge && AlipayJSBridge.call) {
								readyCallback();
							} else {
								//钱包新容器（创建桥的方式是异步的）
								document.addEventListener('AlipayJSBridgeReady', readyCallback, false);
							}
						} else {
							_bridge2.default.Global.setTitle(title);
						}
					}

					/**
      * @method
      * @memberof JSBridge#
      * @desc 唤起App
      * @param scheme {string} App向系统注册的scheme
      * @param packagename {string} App 包名
      * @param path {string}
      * @param query {object}
      * @param isWebView {boolean} 是否webView(调试中大多app的webView ua信息包含chrome但不支持intent协议唤起)
      */

				}, {
					key: 'routApp',
					value: function routApp(options) {
						var type = this.device.type;

						if (type === 'android' && /Chrome/i.test(navigator.userAgent) && !options.isWebView) {
							var intent = 'intent://' + (options.path || '') + (options.query ? '?' + options.query : '') + '#Intent;scheme=' + options.scheme + ';package=' + options.packagename + ';end';
							window.location.replace(intent);
						} else {
							var uriScheme = options.scheme + (options.path || '') + (options.query ? '?' + options.query : '');
							this.sendUriScheme(uriScheme, true, null, true);
						}
					}

					/**
      * @description 在AlipayJSBridgeReady时执行回调方法，且回调仅执行一次。
      * @param {function} fn 回调方法
      */

				}, {
					key: 'alipayCall',
					value: function alipayCall(fn) {
						fn = fn || function () {};
						if (window.AlipayJSBridge && AlipayJSBridge.call) {
							fn();
						} else {
							var once = function once() {
								fn();
								document.removeEventListener('AlipayJSBridgeReady', once, false);
							};
							document.addEventListener('AlipayJSBridgeReady', once, false);
						}
					}
				}]);

				return JSBridge;
			}(_bridge2.default);

			// 表态挂载

			var _jsBridge = new JSBridge();
			for (var k in _jsBridge) {
				if (_jsBridge[k] === undefined) {
					continue;
				}
				JSBridge[k] = _jsBridge[k];
			}
			// 加上 extend 方法
			Object.getOwnPropertyNames(JSBridge.prototype).forEach(function (key) {
				JSBridge[key] = _jsBridge[key];
			});

			// version
			JSBridge.version = "0.1.2";

			// KISSY KMD 兼容
			if (window.KISSY && KISSY.add) {
				KISSY.add('jsbridge/index', function () {
					return JSBridge;
				});
			}

			exports.default = JSBridge;

			/***/
		},
		/* 1 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

			/***/
		},
		/* 2 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

			/***/
		}
		/******/])
	);
});
;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./components/jsbridge/build/index.js
 ** module id = 6
 ** module chunks = 0
 **/